var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "10.797 20.797 189.633 169.925",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2666 184.519H17V137.45H53.2666V184.519ZM98.0244 184.519H61.7578V107.656H98.0244V184.519ZM142.782 184.519H106.517V121.45H142.782V184.519ZM187.541 184.519H151.274V77.3115H187.541V184.519ZM179.409 76.8037L164.641 61.2041L121.309 102.229L118.845 104.561L115.925 102.835L80.0869 81.6543L28.2168 127.579L25.2334 124.21L22.251 120.841L76.5742 72.7451L79.0273 70.5732L81.8467 72.2402L117.584 93.3613L158.453 54.668L143.687 39.0703L194.227 27L179.409 76.8037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.7570000e4dcde1eded477dd2bccd66e0.svg";
export { ForwardRef as ReactComponent };